import React, { useState, useRef, useEffect } from 'react'
import { Editor } from 'react-draft-wysiwyg'
import { Modifier, EditorState } from 'draft-js'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

/** Insere texto literal na posição atual do cursor do editor. */
function insertTextAtCursor(text, editorState, onChange) {
  const contentState = editorState.getCurrentContent()
  const selection = editorState.getSelection()
  const newContent = Modifier.replaceText(
    contentState,
    selection,
    text,
    editorState.getCurrentInlineStyle(),
  )
  const pushed = EditorState.push(editorState, newContent, 'insert-characters')
  onChange(EditorState.forceSelection(pushed, newContent.getSelectionAfter()))
}

/**
 * Botão customizado da toolbar: lista os campos de `contrato` e insere
 * o placeholder {{campo}} no ponto do cursor.
 * react-draft-wysiwyg injeta `editorState` e `onChange` nas props.
 */
const VariableButton = ({ editorState, onChange, campos }) => {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelect = (campo) => {
    if (editorState && onChange) insertTextAtCursor(`{{${campo}}}`, editorState, onChange)
    setOpen(false)
  }

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }} aria-haspopup>
      <div
        className="minuta-var-button"
        onClick={() => setOpen((v) => !v)}
        title="Inserir variável do contrato"
      >
        <i className="mdi mdi-variable mr-1" /> Inserir variável
      </div>
      {open && (
        <div
          style={{
            position: 'absolute',
            zIndex: 1000,
            top: '30px',
            left: 0,
            background: '#fff',
            border: '1px solid #e2e2ee',
            borderRadius: 6,
            boxShadow: '0 4px 14px rgba(0,0,0,0.12)',
            maxHeight: 280,
            overflowY: 'auto',
            minWidth: 240,
          }}
        >
          {(!campos || campos.length === 0) && (
            <div style={{ padding: 10, color: '#74788d', fontSize: '0.82rem' }}>
              Nenhum campo disponível.
            </div>
          )}
          {(campos || []).map((c) => (
            <div
              key={c.campo}
              className="dropdown-item"
              style={{ cursor: 'pointer', padding: '6px 12px', fontSize: '0.84rem' }}
              onClick={() => handleSelect(c.campo)}
            >
              <span>{c.label}</span>
              <code style={{ marginLeft: 6, color: '#0b5ed7', fontSize: '0.78em' }}>{`{{${c.campo}}}`}</code>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

/**
 * Editor de texto rico para cláusulas/blocos.
 * props:
 *  - editorState, onEditorStateChange
 *  - campos: [{ campo, label }] para o botão "Inserir variável"
 */
const RichTextEditor = ({ editorState, onEditorStateChange, campos = [] }) => (
  <Editor
    editorState={editorState}
    onEditorStateChange={onEditorStateChange}
    editorStyle={{
      minHeight: 260,
      border: '1px solid #f1f1f1',
      padding: '0 12px',
      borderRadius: 4,
    }}
    toolbar={{
      options: ['inline', 'list', 'textAlign', 'history'],
      inline: { options: ['bold', 'italic', 'underline'] },
      list: { options: ['unordered', 'ordered'] },
    }}
    toolbarCustomButtons={[<VariableButton campos={campos} />]}
  />
)

export default RichTextEditor
